import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Barra «volver» solo en móvil (< md) para las vistas de detalle de los layouts lista+detalle.
 * En móvil la lista y el detalle no conviven: esta barra es la única salida hacia la lista
 * (en la PWA anclada a inicio no hay botón atrás del navegador).
 * `to` navega a esa ruta; `onBack` sirve para páginas donde la selección es estado local (p. ej. GMB).
 * `children` se pinta a la derecha (acciones de la vista).
 */
export function MobileBackBar({ to, onBack, label, children }) {
  const navigate = useNavigate();
  return (
    <div className="md:hidden sticky top-0 z-20 flex items-center justify-between gap-2 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/70 pr-2">
      <button
        type="button"
        onClick={() => (onBack ? onBack() : navigate(to))}
        className="flex h-11 min-w-0 items-center gap-1.5 px-3 text-sm font-medium text-foreground active:opacity-60"
      >
        <ArrowLeft className="h-5 w-5 shrink-0" strokeWidth={1.75} />
        <span className="truncate">{label}</span>
      </button>
      {children ? <div className="flex shrink-0 items-center gap-2">{children}</div> : null}
    </div>
  );
}
